import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Stories from "@/pages/Stories";
import Reader from "@/pages/Reader";
import Create from "@/pages/Create";
import Contest from "@/pages/Contest";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Reels from "@/pages/Reels";
import SeriesPage from "@/pages/Series";
import SeriesDetail from "@/pages/SeriesDetail";
import Scenes from "@/pages/Scenes";
import SceneDetail from "@/pages/SceneDetail";
import Gems from "@/pages/Gems";
import CompanionDetail from "@/pages/CompanionDetail";
import GiftCreate from "@/pages/GiftCreate";
import GiftClaim from "@/pages/GiftClaim";
import SubmitCompanion from "@/pages/SubmitCompanion";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Library from "@/pages/Library";
import Companions from "@/pages/Companions";
import Admin from "@/pages/Admin";
import Support from "@/pages/Support";
import MyAssets from "@/pages/MyAssets";
import PromoShare from "@/pages/PromoShare";
import { WelcomeSpin } from "@/components/WelcomeSpin";
import InstallAppBanner from "@/components/InstallAppBanner";
import { registerServiceWorker } from "@/lib/registerServiceWorker";
import ThreadReplay from "@/pages/ThreadReplay";
import HumanStories from "@/pages/HumanStories";
import WriteStory from "@/pages/WriteStory";

registerServiceWorker();

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/replay/:threadId" element={<ThreadReplay />} />
          <Route path="/library" element={<Library />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/reels" element={<Reels />} />
          <Route path="/story/:id" element={<Reader />} />
          <Route path="/create" element={<Create />} />
          <Route path="/write" element={<WriteStory />} />
          <Route path="/human-stories" element={<HumanStories />} />
          <Route path="/contest" element={<Contest />} />
          <Route path="/series" element={<SeriesPage />} />
          <Route path="/series/:id" element={<SeriesDetail />} />
          <Route path="/scenes" element={<Scenes />} />
          <Route path="/scenes/:id" element={<SceneDetail />} />
          <Route path="/companions" element={<Companions />} />
          <Route path="/companions/:id" element={<CompanionDetail />} />
          <Route path="/gift/create" element={<GiftCreate />} />
          <Route path="/gift/:id" element={<GiftClaim />} />
          <Route path="/submit-companion" element={<SubmitCompanion />} />
          <Route path="/gems" element={<Gems />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/support" element={<Support />} />
          <Route path="/my/assets" element={<MyAssets />} />
          <Route path="/promo/:id" element={<PromoShare />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
        </Routes>
      </main>
      <WelcomeSpin />
      <InstallAppBanner />
      <footer className="border-t border-white/5 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 text-center text-xs text-slate-500 font-mono uppercase tracking-widest space-y-2">
          <div>ProSeCraft · Stories, unbound</div>
          <div className="flex items-center justify-center gap-4">
            <Link data-testid="footer-support" to="/support" className="hover:text-amber-300">Support</Link>
            <Link data-testid="footer-pricing" to="/pricing" className="hover:text-amber-300">Pricing</Link>
            <Link data-testid="footer-library" to="/library" className="hover:text-amber-300">Library</Link>
          </div>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
